import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentPage: 1,
  pages: {},
  count: 0,
  filter: {
    status: 'OPEN',
    gender: undefined,
    createdAfter: undefined,
    dob: undefined,
    name: undefined,
  },
  sortBy: {
    sortKey: 'createdTimestamp',
    sortOrder: 'DESC',
  },
};

/* eslint no-param-reassign: ["error", { "ignorePropertyModificationsFor": ["state"] }] */
const patientsListSlice = createSlice({
  name: 'patientsList',
  initialState,
  reducers: {
    resetPatientsListState(state) {
      Object.assign(state, initialState);
    },
    updateCurrentPage(state, action) {
      const { page } = action.payload;

      state.currentPage = page;
    },
    loadPatientsToPage(state, action) {
      const { page, patients, count } = action.payload;

      state.count = count;
      state.pages[page] = patients;
    },
    updateSortBy(state, action) {
      const { sortBy } = action.payload;

      state.pages = {}; // Cached data no longer valid, this is to reset it.
      state.count = 0;
      state.sortBy = sortBy;
    },
    updateFilter(state, action) {
      const { filter } = action.payload;

      state.pages = {}; // Cached data no longer valid, this is to reset it.
      state.count = 0;
      state.filter = filter;
    },
    setPatientsListLoading(state, action) {
      state.loading = action.payload;
    },
  },
});

export const patientsListActions = patientsListSlice.actions;
export default patientsListSlice.reducer;
